import {
	FIND_MATCH_CONNECTION_TYPE_SAVED,
	FIND_MATCH_LADDER_SELECTED,
	FIND_MATCH_MODE_STARTED,
	FIND_MATCH_SETTINGS_LOADED,
	MODE_SETTINGS_SAVED,
} from 'react/redux/actions/findMatch';
import { FRIENDLIES } from 'react/matchmaking/findMatch/findMatchModes';

// The Play page's Find a match panel: each mode's saved settings and the
// account's connection type (both from my_user at startup), the game picked in
// its radios, and the mode last started (the LFG button posts that kind).
const initialState = {
	modeSettings: null,
	connectionType: null,
	selectedLadderId: null,
	lastStartedMode: FRIENDLIES,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case FIND_MATCH_SETTINGS_LOADED: {
			const { modeSettings, connectionType } = action.payload;
			return {
				...state,
				modeSettings: modeSettings === undefined ? state.modeSettings : modeSettings,
				connectionType: connectionType === undefined ? state.connectionType : connectionType,
			};
		}
		case MODE_SETTINGS_SAVED:
			return { ...state, modeSettings: action.payload };
		case FIND_MATCH_CONNECTION_TYPE_SAVED:
			return { ...state, connectionType: action.payload };
		case FIND_MATCH_LADDER_SELECTED:
			return { ...state, selectedLadderId: action.payload };
		case FIND_MATCH_MODE_STARTED:
			return { ...state, lastStartedMode: action.payload };
		default:
			return state;
	}
};
